import { css } from '@emotion/react';
import { useTranslation } from '@frontend/i18n';
import { theme } from '@frontend/theme';
import { Tabs } from '@frontend/design-system';
import { quickfillTrackingIds } from '../tracking-ids';
import { useSetRecipientCounts } from './hooks';
import { ManageListTabContent } from './manage-list';
import { SendMessagesTabContent } from './send-messages';

enum PanelTabs {
  SendMessages = 'send-messages',
  ManageList = 'manage-list',
}

export const TrayContent = () => {
  const { t } = useTranslation('schedule-quick-fill');

  useSetRecipientCounts();

  return (
    <Tabs initialTab={PanelTabs.SendMessages}>
      <Tabs.Bar css={{ padding: theme.spacing(0, 3) }}>
        <Tabs.Tab
          id={PanelTabs.SendMessages}
          controls={`${PanelTabs.SendMessages}-panel`}
          trackingId={quickfillTrackingIds.quickfillSendMessageTabButton}
        >
          {t('Send Messages')}
        </Tabs.Tab>
        <Tabs.Tab
          id={PanelTabs.ManageList}
          controls={`${PanelTabs.ManageList}-panel`}
          trackingId={quickfillTrackingIds.quickfillManageListTabButton}
        >
          {t('Manage List')}
        </Tabs.Tab>
      </Tabs.Bar>
      <Tabs.Panel css={tabContentStyle} id={`${PanelTabs.SendMessages}-panel`} controller={PanelTabs.SendMessages}>
        <SendMessagesTabContent />
      </Tabs.Panel>
      <Tabs.Panel css={tabContentStyle} id={`${PanelTabs.ManageList}-panel`} controller={PanelTabs.ManageList}>
        <ManageListTabContent />
      </Tabs.Panel>
    </Tabs>
  );
};

const tabContentStyle = css`
  height: 100%;
  overflow-y: auto;
  background-color: ${theme.colors.neutral5};
  padding: ${theme.spacing(4, 3)};
`;
